var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 100 40"
    },
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1{fill-rule:evenodd;clip-rule:evenodd}.st1{stroke:#000;stroke-miterlimit:10}.st2{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.55 20c0 .62-.58 1.13-1.3 1.13H12.66c-.72 0-1.3-.51-1.3-1.13 0-.62.58-1.13 1.3-1.13h76.59c.72 0 1.3.51 1.3 1.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.82 3.24c0 .3-.13.59-.4.81L11.61 19.88c18.91 16 18.98 16.17 19.11 16.51.23.59-.13 1.24-.8 1.44-.55.17-1.14-.01-1.47-.4-.88-.86-12.16-10.44-19.6-16.74-.25-.21-.39-.51-.39-.81 0-.31.14-.6.4-.81L28.61 2.43c.52-.43 1.34-.42 1.84.03.24.22.37.5.37.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.8c47c23ef80c0c97b7bdd238261cb698.svg";
export { ForwardRef as ReactComponent };